<template>
    <div>
        <ImprimBookTopHeader/>
        <div id="imprimbook-header">
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { inAdministrationSection, inSelfPublishingFlow } from "@/helpers/section";
import ImprimBookTopHeader from "@/components/Hermes/Header/CustomHeader/ImprimBookHeader/ImprimBookTopHeader";

export default {
    name: "ImprimBookHeader",
    components: {ImprimBookTopHeader },
    computed: {
        ...mapGetters("user", {
            user: "user",
            isUserLogged: "isLogged",
            userCart: "cart",
        }),
        inAdministrationSection() {
            return inAdministrationSection(this.$route.name);
        },
    },
    methods: {
        inSelfPublishingFlow,
    },
};
</script>

<style lang="scss" scoped>
    #imprimbook-header {
        background-color: #242021 !important;
        height: 100%;
        width: 100%;
    }

    ul {
        li {
            text-align: center;
            max-width: 150px;
        }
    }
</style>